import 'slick-carousel'

export default function searchSlide() {
    $('.slk-filter-slider').slick({
        autoplay: true,
        arrows: false,
        autoplaySpeed: 5000,
        rtl:true,
    });
}
